import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from "../../apa/Launcher";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class EpgLineUpV1 extends AbstractRequestTask {
  constructor(parameters) {
    
    super();
    this.customParameters = parameters;
  }

  getHeaders() {
    return {};
  }

  getParams() {
    const params = super.getParams();
    delete params.user_token;
    delete params.user_id;
    delete params.device_so;
    delete params.device_name;
    delete params.device_id;
    delete params.api_version;
    delete params.HKS;
    return {
      ...params,
      ...this.customParameters,
      ...{
        metadata: 'full'
      }
      // VALIDAR ESTOS DATOS.
    };
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");

    return `${http}${url}/services/epg/v1/lineup`;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default EpgLineUpV1;



// WEBPACK FOOTER //
// ./src/requests/tasks/epg/EpgLineUpV1.js